import {signal} from "@angular/core";

export class MainStoreService {
    private _whiteLabel = signal<any>(null);
    private _adminWhiteLabel = signal<any>(null);
    private _publisher = signal<any>(null);


    constructor() {

    }
    // *************** whitelabel ****************
    get whiteLabel(){
        return this._whiteLabel();
    }

    set whiteLabel(value: any) {
        this._whiteLabel.set(value);
    }

    // *************** adminWhiteLabel ****************
    get adminWhiteLabel(){
        return this._adminWhiteLabel();
    }
    set adminWhiteLabel(value: any){
        this._adminWhiteLabel.set(value);
    }

    // *************** publisher ****************
    get publisher(){
        return this._publisher();
    }
    set publisher(value: any){
        this._publisher.set(value);
    }

}